@let isEditing =
  serviceCentersEc.plugins.currentEntityPlugin.feature.selectors
    .isEditing()
    .asSignal();
@let isSubmitting =
  serviceCentersEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();

<atn-ds-page>
  <atn-ds-table [config]="tableConfigSg()" />
  @if (isEditing) {
    <atn-space-service-center-modal />
  }
</atn-ds-page>

@if (deletedServiceCenter(); as deletedServiceCenter) {
  @let entityName = svcCenterEntityNameSg();
  @let hasAssignedRecords = deletedServiceCenter.assignedSpaceIds.length > 0;
  @let baseMessage =
    'Deleting ' +
    entityName +
    ' cannot be undone. Are you sure you want to proceed?';
  <atn-ds-confirmation-overlay
    [title]="'Delete ' + entityName"
    [description]="
      hasAssignedRecords
        ? baseMessage +
          '<br/><br/><b>NOTE:</b> Associated records will be switched to Manual mode. Their current allocations will remain unchanged.'
        : baseMessage
    "
    [loading]="isSubmitting"
    confirmButtonText="Delete"
    (confirm)="confirmDeletionClickHandler()"
    (cancel)="cancelDeletionClickHandler()"
  />
}
